"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plaidAccountSubtypes = exports.plaidAccountTypes = exports.accountList_UK = exports.accountList_USA = exports.assetAccounts = exports.deductions_accounts_UK = exports.savings_accounts_UK = exports.deduction_accounts_USA = exports.savings_accounts_USA = exports.debtAccounts = void 0;
exports.debtAccounts = [
    { label: "Credit Card", value: "CREDIT_CARD" },
    { label: "Loan", value: "LOAN" },
    { label: "Other", value: "OTHER" },
];
exports.savings_accounts_USA = [
    {
        label: "Traditional 401K",
        value: "TRADITIONAL_401K",
        canConnectIncome: true,
    },
    { label: "Roth 401k", value: "ROTH_401K", canConnectIncome: true },
    {
        label: "Health Savings Account",
        value: "HSA",
        canConnectIncome: true,
    },
    { label: "Roth IRA", value: "ROTH_IRA" },
    { label: "Traditional IRA", value: "TRADITIONAL_IRA" },
    { label: "Savings Account", value: "SAVING" },
    { label: "Checking Account", value: "CHECKING" },
    { label: "Other", value: "OTHER" },
    {
        label: "Other Deduction",
        value: "OTHER_DEDUCTION",
        canConnectIncome: true,
    },
];
exports.deduction_accounts_USA = [
    {
        label: "TRADITIONAL_401K",
        value: "TRADITIONAL_401K",
        canConnectIncome: true,
        preTax: true,
    },
    {
        label: "Roth 401k",
        value: "ROTH_401K",
        canConnectIncome: true,
        preTax: false,
    },
    {
        label: "Health Savings Account",
        value: "HSA",
        canConnectIncome: true,
        preTax: true,
    },
    {
        label: "Other Deduction",
        value: "OTHER_DEDUCTION",
        canConnectIncome: true,
        preTax: true,
    },
];
exports.savings_accounts_UK = [
    {
        label: "Employers Pension",
        value: "EMPLOYER_PENSION",
        canConnectIncome: true,
    },
    { label: "Self Invested Pension", value: "SIPP", canConnectIncome: true },
    {
        label: "Defined Benefits Pension",
        value: "DEFINED_BENEFITS_PENSION",
        canConnectIncome: true,
    },
    { label: "State Pension", value: "STATE_PENSION" },
    { label: "Stocks and Shares ISA", value: "STOCKS_AND_SHARES_ISA" },
    { label: "LISA", value: "LISA" },
    { label: "Cash ISA", value: "CASH_ISA" },
    { label: "Other", value: "OTHER" },
    { label: "Cash", value: "CASH" },
];
exports.deductions_accounts_UK = [
    {
        label: "Employers Pension",
        value: "EMPLOYER_PENSION",
        canConnectIncome: true,
        preTax: true,
    },
    {
        label: "Self Invested Pension",
        value: "SIPP",
        canConnectIncome: true,
        preTax: false,
    },
    {
        label: "Defined Benefits Pension",
        preTax: true,
        value: "DEFINED_BENEFITS_PENSION",
        canConnectIncome: true,
    },
];
exports.assetAccounts = [
    { label: "Mortgage", value: "MORTGAGE" },
    { label: "Vehicle", value: "VEHICLE" },
    { label: "Other", value: "OTHER" },
];
exports.accountList_USA = {
    ASSET: exports.assetAccounts,
    DEBT: exports.debtAccounts,
    SAVINGS: exports.savings_accounts_USA,
    OTHER: [],
};
exports.accountList_UK = {
    ASSET: exports.assetAccounts,
    DEBT: exports.debtAccounts,
    SAVINGS: exports.savings_accounts_UK,
    OTHER: [],
};
exports.plaidAccountTypes = [
    { plaid_type: "depository", db_value: "SAVINGS" },
    { plaid_type: "credit", db_value: "DEBT" },
    { plaid_type: "investment", db_value: "SAVINGS" },
    { plaid_type: "loan", db_value: "DEBT" },
    { plaid_type: "other", db_value: "OTHER" },
];
exports.plaidAccountSubtypes = [
    { plaid_subtype: "checking", db_value: "CHECKING" },
    { plaid_subtype: "savings", db_value: "SAVING" },
    { plaid_subtype: "hsa", db_value: "HSA" },
    { plaid_subtype: "cd", db_value: "CD" },
    { plaid_subtype: "money market", db_value: "MONEY_MARKET" },
    { plaid_subtype: "paypal", db_value: "PAYPAL" },
    { plaid_subtype: "prepaid", db_value: "PREPAID" },
    { plaid_subtype: "cash management", db_value: "CASH_MANAGEMENT" },
    { plaid_subtype: "ebt", db_value: "EBT" },
    { plaid_subtype: "credit card", db_value: "CREDIT_CARD" },
    { plaid_subtype: "auto", db_value: "AUTO" },
    { plaid_subtype: "business", db_value: "BUSINESS" },
    { plaid_subtype: "commercial", db_value: "COMMERCIAL" },
    { plaid_subtype: "construction", db_value: "CONSTRUCTION" },
    { plaid_subtype: "consumer", db_value: "CONSUMER" },
    { plaid_subtype: "home equity", db_value: "HOME_EQUITY" },
    { plaid_subtype: "loan", db_value: "LOAN" },
    { plaid_subtype: "mortgage", db_value: "MORTGAGE" },
    { plaid_subtype: "overdraft", db_value: "OVERDRAFT" },
    { plaid_subtype: "line of credit", db_value: "LINE_OF_CREDIT" },
    { plaid_subtype: "student", db_value: "STUDENT" },
    { plaid_subtype: "other", db_value: "OTHER" },
    { plaid_subtype: "529", db_value: "COLLEGE_529" },
    { plaid_subtype: "401a", db_value: "EMPLOYER_401A" },
    { plaid_subtype: "401k", db_value: "TRADITIONAL_401K" },
    { plaid_subtype: "403B", db_value: "TRADITIONAL_403B" },
    { plaid_subtype: "457b", db_value: "TRADITIONAL_457B" },
    { plaid_subtype: "brokerage", db_value: "BROKERAGE" },
    { plaid_subtype: "cash isa", db_value: "CASH_ISA" },
    { plaid_subtype: "crypto exchange", db_value: "CRYPTO_EXCHANGE" },
    {
        plaid_subtype: "education savings account",
        db_value: "EDUCATION_SAVINGS_ACCOUNT",
    },
    { plaid_subtype: "fixed annuity", db_value: "FIXED_ANNUITY" },
    { plaid_subtype: "gic", db_value: "GIC" },
    {
        plaid_subtype: "health reimbursement arrangement",
        db_value: "HEALTH_REIMBURSEMENT_ARRANGEMENT",
    },
    { plaid_subtype: "hsa", db_value: "HSA" },
    { plaid_subtype: "ira", db_value: "TRADITIONAL_IRA" },
    { plaid_subtype: "isa", db_value: "TRADITIONAL_ISA" },
    { plaid_subtype: "keogh", db_value: "KEOGH" },
    { plaid_subtype: "lif", db_value: "LIF" },
    { plaid_subtype: "life insurance", db_value: "LIFE_INSURANCE" },
    { plaid_subtype: "lira", db_value: "LIRA" },
    { plaid_subtype: "lrif", db_value: "LRIF" },
    { plaid_subtype: "lrsp", db_value: "LRSP" },
    { plaid_subtype: "mutual fund", db_value: "MUTUAL_FUND" },
    { plaid_subtype: "non-custodial wallet", db_value: "NON_CUSTODIAL_WALLET" },
    {
        plaid_subtype: "non-taxable brokerage account",
        db_value: "NON_TAXABLE_BROKERAGE_ACCOUNT",
    },
    { plaid_subtype: "other annuity", db_value: "OTHER_ANNUITY" },
    { plaid_subtype: "other insurance", db_value: "OTHER_INSURANCE" },
    { plaid_subtype: "pension", db_value: "PENSION" },
    { plaid_subtype: "prif", db_value: "PRIF" },
    { plaid_subtype: "profit sharing plan", db_value: "PROFIT_SHARING_PLAN" },
    { plaid_subtype: "qshr", db_value: "QSHR" },
    { plaid_subtype: "rdsp", db_value: "RDSP" },
    { plaid_subtype: "resp", db_value: "RESP" },
    { plaid_subtype: "retirement", db_value: "RETIREMENT" },
    { plaid_subtype: "rlif", db_value: "RLIF" },
    { plaid_subtype: "roth", db_value: "ROTH_IRA" },
    { plaid_subtype: "roth 401k", db_value: "ROTH_401K" },
    { plaid_subtype: "rrif", db_value: "RRIF" },
    { plaid_subtype: "rrsp", db_value: "RRSP" },
    { plaid_subtype: "sarsep", db_value: "SARSEP" },
    { plaid_subtype: "sep ira", db_value: "SEP_IRA" },
    { plaid_subtype: "simple ira", db_value: "SIMPLE_IRA" },
    { plaid_subtype: "sipp", db_value: "SIPP" },
    { plaid_subtype: "stock plan", db_value: "STOCK_PLAN" },
    { plaid_subtype: "tfsa", db_value: "TFSA" },
    { plaid_subtype: "trust", db_value: "TRUST" },
    { plaid_subtype: "ugma", db_value: "UGMA" },
    { plaid_subtype: "utma", db_value: "UTMA" },
    { plaid_subtype: "variable annuity", db_value: "VARIABLE_ANNUITY" },
];
